export const OperacionAFOCLTablaValorFields = {
    CodOperacionAFOCLTablaValor: 'codOperacionAFOCLTablaValor',
    IdOperacionAFOCL: 'idOperacionAFOCL',
    CodInstrumento: 'codOperacionAFOCLInstrumento',
    DescInstrumento: 'descInstrumento',
    CodOperacionTipo: 'codOperacionAFOCLOperacionTipo',
    DescOperacionTipo: 'descOperacionTipo',
    ValorPuente: 'aforoPuente',
    ValorCliente: 'aforoCliente',
    OrdenInstrumento: 'ordenInstrumento',
    OrdenOperacionTipo: 'ordenOperacionTipo',
    PermiteEditar: 'permiteEditar',
} as const

export const OperacionAFOCLFields = {
    CodOperacionAFOCL: 'idOperacionAFOCL',
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    CodUnidadNegocio: 'codUnidadNegocio',
    DescUnidadNegocio: 'descUnidadNegocio',
    CodSectorComercial: 'codSectorComercial',
    DescSectorComercial: 'descSectorComercial',
    NumeroCuenta: 'numeroCuenta',
    RazonSocial: 'razonSocial',

    FechaSolicitud: 'fechaSolicitud',
    FechaVencimiento: 'fechaVencimiento',
    CodEstado: 'codEstado',
    DescEstado: 'descEstado',
    Observaciones: 'observaciones',

    TablaValores: 'tablaValores',

    FechaAprobacion: 'fechaAprobacion',
    FechaAlta: 'fechaAlta',
    IdUsuarioAlta: 'idUsuarioAlta',
    NombreUsuarioAlta: 'nombreUsuarioAlta',
    ApellidoUsuarioAlta: 'apellidoUsuarioAlta',
    MailUsuarioAlta: 'mailUsuarioAlta',
    IdUsuarioUltMod: 'idUsuarioUltMod',
    NombreUsuarioUltMod: 'nombreUsuarioUltMod',
    ApellidoUsuarioUltMod: 'apellidoUsuarioUltMod',
    MailUsuarioUltMod: 'mailUsuarioUltMod',
    EstadoFinalizado: 'estadoFinalizado',
    IdMensaje: 'idMensaje',
    PermiteEditarOperacion: 'permiteEditarOperacion',
    PermiteEliminarOperacion: 'permiteEliminarOperacion',
} as const